import { prepareCommonCarriageData, sendCarriage } from "./sendCarriageCommon";
import { type LinearConfigurationUpdate } from "../../Linear/models";
import {
  prepareApiDataForResetNew,
  prepareApiDataForResetNewest,
  prepareGroupIdToDisplay,
} from "../../common/commonConfiguratorApi";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import { ConfiguratorType } from "~/Configurators/ConfiguratorType";
import { transformUpdate } from "~/Configurators/Linear/linearDataTransformer";
import { KWLT_CARRIAGE_CONFIGURATOR_PRODUCT_CODE } from "~/Configurators/constants";

export async function sendCarriageDataReset(linearState: LinearConfiguratorState): Promise<LinearConfigurationUpdate> {
  const data = prepareCommonCarriageData(linearState);
  const productCode = linearState.productCode;

  const resetData =
    productCode === KWLT_CARRIAGE_CONFIGURATOR_PRODUCT_CODE
      ? prepareApiDataForResetNewest(linearState)
      : prepareApiDataForResetNew(linearState);

  prepareGroupIdToDisplay(data);

  // For Step 3 - we need to send a special flag to reload the default values for the carriage details substep
  if (linearState.currentStep === 2) {
    data.carriagesConfiguratorData.enableConfigureCarriageValues = false;
  }

  const response = await sendCarriage({
    ...data,
    ...resetData,
  });
  return transformUpdate(response, ConfiguratorType.Carriage);
}
